import React, { useEffect, useState } from "react";
import { Header, Sidebar } from "../Layout";
import { Link } from "react-router-dom";
import { getProjectStatusList, getProjectFilter } from "../../actions/projectActions";
import { getPartners } from "../../actions/partnerActions";
import { useSelector, useDispatch } from "react-redux";
import DataTablesProject from "./ActivityScheduleTables/DataTablesProject";
import DatePicker from "react-datepicker";
import moment from "moment";
import { MEMBER } from '../../constants/constants';
import { updateProjectShortCuts } from '../../actions/userDashboardAction';

const ActivitySchedule = () => {

    const dispatch = useDispatch();

    const { user } = useSelector(state => state.auth);
    const { projects, project_status } = useSelector(state => state.projectStore);
    const { partners } = useSelector(state => state.partnerStore);
    const [startDate, setStartDate] = useState(new Date());
    const [inputProjectData, setProjectData] = useState()
    const [searchInput, setSearchInput] = useState("")
    const [partner, setPartner] = useState("")
    const [dueDate, setDueDate] = useState("")
    const [status, setStatus] = useState("")

    useEffect(() => {
        dispatch(getProjectFilter(searchInput, partner, dueDate, status))
    }, [dispatch ,searchInput, partner, dueDate, status])

    useEffect(() => {
        setProjectData(projects)
    }, [projects])

    useEffect(() => {
        dispatch(getPartners());
        dispatch(getProjectStatusList());
    }, [dispatch])


    const handleChange = e => {
        if (e.target.name === 'searchInput') {
            setSearchInput(e.target.value)
        } else if (e.target.name === 'partner') {
            setPartner(e.target.value)
        } else if (e.target.name === 'due_date') {
            setDueDate(e.target.value)
        } else if (e.target.name === 'status') {
            setStatus(e.target.value)
        } else {
            setSearchInput('');
            setPartner('');
            setDueDate('');
            setStatus('');
            setStartDate(new Date());
        }
    }

    const onSelectDate = (date) => {
        setDueDate(moment(date).format('YYYY-MM-DD'))
        setStartDate(date)
    }
    const handleSubmitBlockUnblock = (userStatus) => {
        let projectData = {
            project_id: userStatus.id,
            is_in_shortcuts: !userStatus.is_shortcuts
        }
        console.log(projectData)
        dispatch(updateProjectShortCuts(projectData))
    }
    return (
        <>
            <Header />
            <Sidebar />
            <div id="main-content">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Activity Schedule</h2>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/"><i className="icon-home"></i></Link></li>
                                <li className="breadcrumb-item active">Activity Schedule</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row clearfix py-3">
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <h3 className="text-bold"><strong>Activity Schedule</strong></h3>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 text-right">
                            {
                                (user?.userType === MEMBER) ? <></> :
                                    <Link to='/project-create' className="header-dropdown dropdown dropdown-animated scale-left btn button text-right text-white"><i className="fa fa-plus-circle fa-lg mr-2"></i>Create New Brief</Link>
                            }
                        </div>
                    </div>
                    <div className="row clearfix">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="card card-radius">
                                <div className="header card-header custum-bg-warning rounded flex_none pb-0">
                                    <div className="row">
                                        <div className="col-lg-3 col-md-3 col-sm-12">
                                            <div className="form-group relative_pos">

                                                <input
                                                    className="form-control custum-bg-warning text-white custom-placeholder"
                                                    type={'text'}
                                                    name="searchInput"
                                                    value={searchInput}
                                                    onChange={handleChange}
                                                    placeholder={'Search....'} />
                                                <span className="searchInput"><i className="icon-magnifier"></i></span>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-sm-12 col-lg-2"></div>
                                        <div className="col-lg-2 col-md-4 col-sm-12 padding_5">
                                            <div className="form-group">
                                                <select value={partner} onChange={handleChange} className="form-control custum-bg-warning text-white" name={'partner'}>
                                                    <option value={''}>Select Partner</option>
                                                    {partners && partners.map((partner, index) => (
                                                        partner.agency_name && <option key={index} value={partner.id}>{partner.agency_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-4 col-sm-12 padding_5">
                                            <div className="form-group">
                                                <DatePicker
                                                    selected={startDate}
                                                    onChange={(date) => onSelectDate(date)}
                                                    name="project_end_date"
                                                    id="project_end_date"
                                                    className="form-control custum-bg-warning text-white" />
                                                <span className="searchInput"><i className="fa fa-calendar-o color-white" aria-hidden="true"></i></span>

                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-4 col-sm-12 padding_5">
                                            <div className="form-group">
                                                <select value={status} onChange={handleChange} className="form-control custum-bg-warning text-white" name={'status'}>
                                                    <option value={''}>Status</option>
                                                    {project_status && project_status.map((status, index) => (
                                                        <option key={index} value={status.value}>{status.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-1 col-md-2 col-sm-12 padding_5">
                                            <button className="btn button p-2" onClick={handleChange}>Clear</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="body text-center card-body-shadow">
                                    <DataTablesProject
                                        data={inputProjectData} changeStatus={handleSubmitBlockUnblock}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default ActivitySchedule;